module.exports = __webpack_public_path__ + "static/media/UsageEmail.93a3779e.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/views/CustomerPages/UsageEmail.PNG
// module id = 877
// module chunks = 0